import { all, takeLatest, put, call } from 'redux-saga/effects';

import { apiPauseSubscription } from '@dragonfruit/services/apis';
import { showAlertBanner } from '@dragonfruit/redux/alertBanner';
import { fetchPurchaseHistory } from '@dragonfruit/redux/purchaseHistory';
import {
  PAUSE_SUBSCRIPTION,
  pauseSubscriptionSuccess,
  pauseSubscriptionError,
} from '@dragonfruit/redux/modifySubscription';
import {
  ALERT_ERROR_THEME,
  ALERT_SUCCESS_THEME,
} from '@dragonfruit/constants/alertBannerThemes';

export function* pauseSubscriptionFlow(action) {
  const { subscriptionId, billingCycles } = action.payload;
  try {
    yield call(apiPauseSubscription, {
      subscriptionId,
      billingCycles,
    });
    yield put(pauseSubscriptionSuccess());

    yield put(
      showAlertBanner({
        message: 'account.pauseSubscriptionSuccess',
        theme: ALERT_SUCCESS_THEME,
      })
    );
    yield put(fetchPurchaseHistory());
  } catch (error) {
    yield put(pauseSubscriptionError(error.message));
    yield put(
      showAlertBanner({
        message: error.message,
        theme: ALERT_ERROR_THEME,
      })
    );
  }
}

export default function*() {
  yield all([takeLatest(PAUSE_SUBSCRIPTION, pauseSubscriptionFlow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/modifySubscription.js